@if (headerService.title || headerService.icon || headerService.backIsVisible) {
<div class="flex align-items-center justify-content-between py-4 md:flex-row">
  <div class="flex align-items-center">
    @if (headerService.backIsVisible) {
    <p-button icon="pi pi-arrow-left" (onClick)="headerService.back()" [rounded]="true" [text]="true"
      severity="secondary" size="small" />
    <p-divider layout="vertical" class="p-0" />

    }
    @if (headerService.icon) {
    <div
      [class]="'flex align-items-center justify-content-center border-round w-3rem h-3rem font-bold text-xl mr-3 shadow-1 ' + headerService.bgClass + ' ' + headerService.textClass">
      <i [class]="headerService.icon"></i>
    </div>
    }
    <span class="p-2 font-bold text-2xl text-900">{{ headerService.title }}</span>
  </div>
</div>
}